// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__NSgIO","newExpiryDate":"styles_newExpiryDate__1er2R","footer":"styles_footer__2IVYB"};